import React from "react";
import Image from "next/legacy/image";
import {
  CocoImageContainer,
  NpsThankyouScreenContainer,
  SeeYouLaterCTA,
  ThakyouScreenStyledButtonContainer,
  ThankyouScreenHeading,
  ThankyouScreenSubheading
} from "./nps-thankyou-and-skip-confirmation.styles";
import { Button } from "components/atoms/button/button";
import { useNpsThankyouScreen } from "./useNpsThankyouAndSkipConfirmation";
import {
  INpsThankyouAndSkipConfirmationScreen,
  NpsThankyouAndSkipConfirmationScreenVariants
} from "./nps-thankyou-and-skip-confirmation.types";
import { NpsThankyouAndSkipConfirmationData } from "./nps-thankyou-and-skip-confirmation.data";

const NpsThankyouAndSkipConfirmation = ({
  variant,
  handleModalClose,
  toggleSkipConfirmation
}: INpsThankyouAndSkipConfirmationScreen): JSX.Element => {
  const { handleProceed, handleSeeYouLater } = useNpsThankyouScreen({
    handleModalClose,
    toggleSkipConfirmation
  });

  return (
    <NpsThankyouScreenContainer>
      <CocoImageContainer
        isSkipConfirmation={
          variant ===
          NpsThankyouAndSkipConfirmationScreenVariants.SKIP_CONFIRMATION
        }
      >
        <Image
          src={NpsThankyouAndSkipConfirmationData[variant].imageSrc}
          alt="coco-image"
          layout="responsive"
          width={224}
          height={224}
        />
      </CocoImageContainer>
      <ThankyouScreenHeading>
        {NpsThankyouAndSkipConfirmationData[variant].heading}
      </ThankyouScreenHeading>
      <ThankyouScreenSubheading>
        {NpsThankyouAndSkipConfirmationData[variant].subheading}
      </ThankyouScreenSubheading>
      <ThakyouScreenStyledButtonContainer>
        <Button
          isFullWidth={true}
          onClick={() => handleProceed(variant)}
          variant="primary"
        >
          {NpsThankyouAndSkipConfirmationData[variant].buttonText}
        </Button>
      </ThakyouScreenStyledButtonContainer>
      {variant === "skipConfirmation" && (
        <SeeYouLaterCTA onClick={() => handleSeeYouLater()}>
          Ntar aja 😢
        </SeeYouLaterCTA>
      )}
    </NpsThankyouScreenContainer>
  );
};

export { NpsThankyouAndSkipConfirmation };
